import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useFetchCLByPrescription } from "../../../../../../../../../../../hooks/modules/EcommContent/ContactLensesEcommContent/hooks/use-fetch-cl-by-prescription.js";
import { useCLEcommContext } from "../../../../../../../../../../../context/modules/EcommContent/ContactLensesEcommContent/context/CLEcommContext.js";
const DummyAddToCartCTA = ({ className }) => {
  const { getLabel } = useIntl();
  const { actions, state, selectors, triggerToastMessage } = useCLEcommContext();
  const { configurations } = state;
  const isLoading = selectors.hasQueryLoading(state);
  const fetchLeftCL = useFetchCLByPrescription({ eyeSide: "left" });
  const fetchRightCL = useFetchCLByPrescription({ eyeSide: "right" });
  const fetchBothCL = useFetchCLByPrescription({ eyeSide: "both" });
  const hasLeftRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, "left");
  const hasRightRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, "right");
  const hasBothRecoverableError = selectors.hasRecoverableErrorOnEyeside(state, "both");
  const hasRecoverableError = selectors.hasRecoverableError(state);
  const hasNonRecoverableError = selectors.hasNonRecoverableError(state);
  const hasNonExecutableQueryError = selectors.hasNonExecutableQueryError(state);
  const isOneColConfigurator = selectors.isOneColConfigurator(state);
  const triggerValidations = React.useCallback(() => {
    if (!hasNonRecoverableError) {
      actions.triggerValidationErrors();
    }
    if (hasNonRecoverableError) {
      triggerToastMessage("non-recoverable-rx-error");
    }
    if (hasRecoverableError && !hasNonRecoverableError) {
      triggerToastMessage("recoverable-error");
    }
    if (hasNonExecutableQueryError) {
      triggerToastMessage("generic-non-recoverable-error");
    }
    if (isOneColConfigurator) {
      hasBothRecoverableError && fetchBothCL(configurations.both.prescription);
    } else {
      hasLeftRecoverableError && fetchLeftCL(configurations.left.prescription);
      hasRightRecoverableError && fetchRightCL(configurations.right.prescription);
    }
  }, [
    hasNonRecoverableError,
    hasRecoverableError,
    hasNonExecutableQueryError,
    isOneColConfigurator,
    actions,
    triggerToastMessage,
    hasBothRecoverableError,
    fetchBothCL,
    configurations.both.prescription,
    configurations.left.prescription,
    configurations.right.prescription,
    hasLeftRecoverableError,
    fetchLeftCL,
    hasRightRecoverableError,
    fetchRightCL
  ]);
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      className,
      "data-t": "btn-enter-prescription",
      caption: getLabel("products.actions.addToCart"),
      onClick: triggerValidations,
      isLoading
    }
  );
};
export {
  DummyAddToCartCTA
};
//# sourceMappingURL=DummyAddToCartCTA.js.map
